// Function loadTabContainer loads the TabContainer class by dynamically importing the js on demand if needed

export function loadTabContainer($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-tab-container-chunk" */ '../widgets/tabContainer').then(wg => {

		const { TabContainer } = wg;

		let $wg = $parentEl.querySelector('[data-wg="TabContainer"]');

		if(!$wg) {
			// console.info('TabContainer: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="TabContainer"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new TabContainer($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new TabContainer($wg);
		}


	}).catch(error => error+'An error occurred while loading the TabContainer widget');

}
